import type { ReactNode } from 'react';
import { Icon, type IconName } from '@/design-system/icons/Icon';

type Props = { icon?: IconName; title: string; description?: string; action?: ReactNode };

export const EmptyState = ({ icon = 'sparkles', title, description, action }: Props) => (
  <div style={{ textAlign: 'center', padding: '40px 24px', color: 'var(--ink-3)' }}>
    <Icon name={icon} size={28} />
    <h4 style={{ margin: '12px 0 6px', color: 'var(--ink)' }}>{title}</h4>
    {description && <p style={{ margin: 0, maxWidth: 420, marginInline: 'auto' }}>{description}</p>}
    {action && <div style={{ marginTop: 16 }}>{action}</div>}
  </div>
);
